export default defineAppConfig({
  title: "Nest List",
});
